import { render } from "./EpiProperty.vue?vue&type=template&id=7bd90842"
import script from "./EpiProperty.vue?vue&type=script&lang=js"
export * from "./EpiProperty.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__